module.exports = __webpack_public_path__ + "static/img/SDL.5654da7.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/1x/SDL.png
// module id = qHPA
// module chunks = 1